
import { defineComponent } from 'vue'
import SideBar from '@/components/SideBar.vue'
import PageTitle from '@/components/PageTitle.vue'

export default defineComponent({
    name: 'ScheduledInvoices',
    components: { PageTitle, SideBar }
})
